module.exports = __webpack_public_path__ + "img/mobile-logo.bff6d223.png";